import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { WALLET_IMG } from '../../config/constants/images';
import { GIFT_CARD_WALLET } from '../../config/text/text';
import {
  getCountryCurrency,
  getCountryCurrencyCode,
} from '../../helpers/currency';
import ThemeContext from '../../providers/ThemeProvider';

const Wallet = ({ isWalletPage = false, userWallet }) => {
  const theme = useContext(ThemeContext);
  const img = WALLET_IMG[process.env.NEXT_PUBLIC_SITE];
  const { title, text, altImg } = GIFT_CARD_WALLET[
    process.env.NEXT_PUBLIC_SITE
  ].walletContent;
  const currency = getCountryCurrency();
  const walletClass = classNames(`wallet`, {
    'wallet__is-wallet-page': isWalletPage,
  });
  const [balance, setBalance] = useState(0);
  const [splitBalance, setSplitBalance] = useState(
    balance.toFixed(2).split(''),
  );
  const setWalletBalance = () => {
    const currencyWallet = userWallet.find(
      (wallet) => wallet.currency === getCountryCurrencyCode(),
    );
    if (!currencyWallet) return false;
    const temporaryBalance = currencyWallet?.balanceWithoutExperienceCredit;
    if (!temporaryBalance || typeof temporaryBalance !== 'number') return false;
    setBalance(temporaryBalance);
  };
  const setWalletSplitBalance = () => {
    setSplitBalance(balance.toFixed(2).split(''));
  };

  useEffect(() => {
    if (userWallet) setWalletBalance();
  }, [userWallet]);

  useEffect(() => {
    setWalletSplitBalance();
  }, [balance]);

  return (
    <>
      <div className={walletClass}>
        <div className="wallet__heading">
          <span className="wallet__digit">{currency}</span>
          {splitBalance.map((item, index) => (
            <span className="wallet__digit" key={`wallet__digit--${index}`}>
              {item}
            </span>
          ))}
        </div>
        <div className="wallet__body">
          <div className="wallet__details">
            <div className="wallet__title">{title}</div>
            <div className="wallet__txt">{text}</div>
          </div>
          <img alt={altImg} className="wallet__img" src={img} />
        </div>
      </div>
      <style jsx>{`
        .wallet {
          background-color: #b7a47b;
          background-image: linear-gradient(#b7a47b, #dbd2bd);
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          padding: 10px;
          box-shadow: 2px 2px 6px #333333;
          width: 100%;
        }
        .wallet__is-wallet-page {
          margin: 0 0 24px 0;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .wallet__is-wallet-page {
            float: right;
            margin: 0 0 24px 24px;
            max-width: 300px;
          }
        }
        .wallet__heading {
          background-color: black;
          background-image: linear-gradient(black, #4d4d4d);
          border-radius: 4px;
          border: 1px solid black;
          padding: 12px 0 0 6px;
        }
        .wallet__digit {
          background: white;
          display: inline-block;
          padding: 0 3px;
          text-align: center;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          font-size: 2.8rem;
          width: 22px;
          margin: 0 1px;
          font-weight: normal;
          line-height: 1.4;
        }
        .wallet__body {
          display: flex;
          padding: 10px 0 10px 0;
          min-height: 90px;
          align-items: center;
        }
        .wallet__img {
          margin-left: auto;
          max-width: 90px;
        }
        .wallet__title {
          font-size: 2rem;
          font-weight: 700;
        }
        .wallet__txt {
          font-size: 1.6rem;
          font-style: italic;
        }
      `}</style>
    </>
  );
};

Wallet.propTypes = {
  isWalletPage: PropTypes.bool,
  userWallet: PropTypes.array,
};

export default Wallet;
